import React from 'react';
import _ from 'lodash';
import ReadingListItem from './ReadingListItem.jsx';

const isMobile = () => window.innerWidth <= 768;

const ReadingListItems = ({ articles = [], answers = [] }) => {
  const [mobile, setMobile] = React.useState(isMobile());
  React.useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const answersByArticleId = _.keyBy(answers, (a) => String(a.article));
  return (
    <div
      className={mobile ? 'px-2' : 'px-2'}
      style={{
        gap: 8,
      }}
    >
      {_.map(articles, (article, idx) => {
        if (!article) return null;
        const answer = article.answer || answersByArticleId[String(article._id)] || null;
        const uniqueKey = answer && answer._id
          ? `${answer._id}-${article._id || idx}`
          : `${article._id || 'article'}-${idx}`;
        return <ReadingListItem key={uniqueKey} article={article} answer={answer} />;
      })}
    </div>
  );
};

export default ReadingListItems;
